import React from "react";
import styles from "./iconpicker.module.css";
import { SvgIcon } from "@progress/kendo-react-common"
import {
    Asterisk,
    FileText,
    Pen,
    X,
    Plus,
    Warning,
    FilePdf,
    CheckCircle,
    Circle,
    DotOutline,
    Check,
    Lock,
    Eye,
    Funnel,
    ArrowElbowDownRight,
    ArrowsDownUp,
    Timer,
    Boat,
    UsersThree,
    HandCoins,
    Calendar,
    ClockCounterClockwise,
    BookOpenText,
    Medal,
    Database,
    NotePencil,
    AddressBook,
    MapPin,
    Alarm,
    Gear,
    IdentificationBadge,
    ArrowCircleLeft,
    ArrowCircleRight,
    ArrowCircleUp,
    ArrowCircleDown,
    Info,
    House,
    SignOut,
    Rows,
    SquaresFour,
    PaperPlaneTilt,
    Square,
    ArrowCounterClockwise,
    ArrowsCounterClockwise,
    UserSwitch,
    Broadcast,
    Archive,
    EnvelopeSimple,
    Bell,
    ChatCircle,
    Paperclip,
    Trash,
    PlayCircle,
    PauseCircle,
    CaretUp,
    CaretDown,
    CaretLeft,
    MagnifyingGlass,
    DownloadSimple,
    GraduationCap,
    CalendarCheck,
    DotsThreeOutlineVertical,
    SealCheck,
    CaretDoubleLeft,
    CaretDoubleRight,
} from "phosphor-react-sc";
import { MapSegmentsDuotoneIcon, ShipDuotoneIcon } from "./Icons"
import { SvgStyle } from "../SvgStyle"
import { CalendarDots } from "@phosphor-icons/react";

const iconMap: Record<string, (props: any) => JSX.Element> = {
    "address-book": (props) => <AddressBook {...props} />,
    "alarm": (props) => <Alarm {...props} />,
    "archive": (props) => <Archive {...props} />,
    "arrow-circle-left": (props) => <ArrowCircleLeft {...props} />,
    "arrow-circle-right": (props) => <ArrowCircleRight {...props} />,
    "arrows-down-up": (props) => <ArrowsDownUp {...props} />,
    "arrow-elbow-down-right": (props) => <ArrowElbowDownRight {...props} />,
    "arrow-circle-up": (props) => <ArrowCircleUp {...props} />,
    "arrow-circle-down": (props) => <ArrowCircleDown {...props} />,
    "arrow-counter-clockwise": (props) => <ArrowCounterClockwise {...props} />,
    "arrows-counter-clockwise": (props) => <ArrowsCounterClockwise {...props} />,
    "asterisk": (props) => <Asterisk {...props} />,
    "bell": (props) => <Bell {...props} />,
    "boat": (props) => <Boat {...props} />,
    "book-open-text": (props) => <BookOpenText {...props} />,
    "broadcast": (props) => <Broadcast {...props} />,
    "calendar": (props) => <Calendar {...props} />,
    "calendar-check": (props) => <CalendarCheck {...props} />,
    "calendar-dots": (props) => <CalendarDots {...props} />,
    "caret-double-left": (props) => <CaretDoubleLeft {...props} />,
    "caret-double-right": (props) => <CaretDoubleRight {...props} />,
    "caret-down": (props) => <CaretDown {...props} />,
    "caret-left": (props) => <CaretLeft {...props} />,
    "caret-up": (props) => <CaretUp {...props} />,
    "chat-circle": (props) => <ChatCircle {...props} />,
    "check": (props) => <Check {...props} />,
    "check-circle": (props) => <CheckCircle {...props} />,
    "circle": (props) => <Circle {...props} />,
    "clock-counter-clockwise": (props) => <ClockCounterClockwise {...props} />,
    "database": (props) => <Database {...props} />,
    "dot-outline": (props) => <DotOutline {...props} />,
    "dots-three-outline-vertical": (props) => <DotsThreeOutlineVertical {...props} />,
    "document": (props) => <FileText {...props} />,
    "download-simple": (props) => <DownloadSimple {...props} />,
    "edit": (props) => <Pen {...props} />,
    "envelope-simple": (props) => <EnvelopeSimple {...props} />,
    "eye": (props) => <Eye {...props} />,
    "funnel": (props) => <Funnel {...props} />,
    "gear": (props) => <Gear {...props} />,
    "hand-coins": (props) => <HandCoins {...props} />,
    "house": (props) => <House {...props} />,
    "identification-badge": (props) => <IdentificationBadge {...props} />,
    "info": (props) => <Info {...props} />,
    "lock": (props) => <Lock {...props} />,
    "map-pin": (props) => <MapPin {...props} />,
    "map-segments": (props) => <SvgIcon icon={MapSegmentsDuotoneIcon} style={SvgStyle(props.size)} className={props.className} />,
    "magnifying-glass": (props) => <MagnifyingGlass {...props} />,
    "medal": (props) => <Medal {...props} />,
    "note-pencil": (props) => <NotePencil {...props} />,
    "paper-plane-tilt": (props) => <PaperPlaneTilt {...props} />,
    "paperclip": (props) => <Paperclip {...props} />,
    "pdf": (props) => <FilePdf {...props} />,
    "pause-circle": (props) => <PauseCircle {...props} />,
    "pilots-ship": (props) => (
        <IconPickerDoubleIcon
            size={props.size}
            icon1={<SvgIcon icon={ShipDuotoneIcon} style={SvgStyle(props.size * 0.75)} />}
            icon2={<UsersThree size={props.size * 0.65} className="pointer" weight={props.weight} />}
        />
    ),
    "play-circle": (props) => <PlayCircle {...props} />,
    "plus": (props) => <Plus {...props} />,
    "rows": (props) => <Rows {...props} />,
    "seal-check": (props) => <SealCheck {...props} />,
    "ship": (props) => <SvgIcon icon={ShipDuotoneIcon} {...props} style={SvgStyle(props.size)} />,
    "sign-out": (props) => <SignOut {...props} />,
    "square": (props) => <Square {...props} />,
    "squares-four": (props) => <SquaresFour {...props} />,
    "timer": (props) => <Timer {...props} />,
    "trash": (props) => <Trash {...props} />,
    "user-switch": (props) => <UserSwitch {...props} />,
    "users-three": (props) => <UsersThree {...props} />,
    "warning": (props) => <Warning {...props} />,
    "graduation-cap": (props) => <GraduationCap {...props} />,
    "x": (props) => <X {...props} />,
};

interface IconPickerProps {
    icon: IconName;
    color?: string;
    size?: number;
    weight?: "duotone" | "fill" | "light" | "regular" | "thin" | "bold";
    role?: "button" | "icon";
    opacity?: number;
    className?: string;
}

export const IconPicker = ({
    icon,
    size = 16,
    color = "var(--font-primary)",
    weight = "duotone",
    role = "button",
    opacity = 1,
    className = "",
}: IconPickerProps) => {
    const customProps = {
        size,
        weight,
        color,
        role,
        title: icon,
        style: { opacity },
        className,
    };

    if (!icon || icon.trim() === "") {
        return <X {...customProps} />;
    }

    const key = icon.toLowerCase().trim() as IconName;
    const IconComponent = iconMap[key];

    if (IconComponent) {
        return IconComponent(customProps);
    }

    return <X {...customProps} />;
};

interface IconPickerDoubleIconProps {
    size: number,
    icon1: React.ReactNode,
    icon2: React.ReactNode
}
const IconPickerDoubleIcon = ({
    size,
    icon1,
    icon2
}: IconPickerDoubleIconProps) => {

    return (
        <div className={styles.doubleIcon} style={{ width: (size), height: size }}>
            <div className={styles.doubleIcon1}>{icon1}</div>
            <div className={styles.doubleIcon2}>{icon2}</div>
        </div>
    )
}
